import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Color } from "@lib/color";
import { Configs, ConfigStore } from "./config-store";
import { HighchartsThemeEngine } from "./highcharts-theme-engine";

@Injectable({
	providedIn: "root",
})
export class AppConfigService {
	public configs:Configs = null;

	constructor() {
	}

	load() {
		/*
			Serving Configs from Whitelabel App. Disabling it temporarily

			const url = 'api/white_labels/configs';
			return getPromise(url).then(configs=> {
				this.configs = configs;
				ConfigStore.setConfig(this.configs);
				this.applyConfigurations();

				return this.configs;
			})
		*/

		this.configs = environment.configs;
		ConfigStore.setConfig(this.configs);
		this.applyConfigurations();

		HighchartsThemeEngine.apply(this.configs.themes.primaryColor);
	}

	private applyConfigurations() {
		const { branding, themes } = this.configs;

		if(branding.favIcon){
			const link: HTMLLinkElement=document.querySelector('#appIcon') || document.createElement('link');
			link.rel='icon';
			link.href=branding.favIcon;
			document.head.appendChild(link);
		}

		if(themes?.primaryColor){
			document.documentElement.style.setProperty('--primary-color', themes.primaryColor);
			const color=Color.html(themes.primaryColor);
			document.documentElement.style.setProperty('--primary-rgb-color', `${color.r*255}, ${color.g*255}, ${color.b*255}`);

			const reportProps = themes?.reports;
			if (reportProps) {
				const { stripBar1Color, stripBar3Color } = reportProps;
				document.documentElement.style.setProperty('--reports-stripbar1-color', stripBar1Color);
				document.documentElement.style.setProperty('--reports-stripbar3-color', stripBar3Color);
			}
		}
	}
}